import styled from 'styled-components'

import { Card as CardComp } from 'src/components/Ant'

const Card = styled(CardComp)`
  margin-bottom: 16px;
`

const SpanFilled = styled.span`
  padding-right: 8px;
`

export { SpanFilled, Card }
